import { Action, createReducer, on } from '@ngrx/store';
import { ErrorResponse, IGenericError } from 'src/app/core/models/generic-models';
import * as complianceActions from '../actions/static-data-compliance.actions';
import { IStaticDataResponse } from '../models/static-data.model';

export const staticDataJurisdictionRisksFeatureKey = 'staticDataJurisdictionRisks';

export interface StaticDataJurisdictionRisksState {
  loading: boolean;
  data: IStaticDataResponse[];
  error: any;
}

export const initialState: StaticDataJurisdictionRisksState = {
  loading: false,
  data: [],
  error: null
};

export const reducer = createReducer(
  initialState,
  on(complianceActions.loadJurisdictionRisks, state => ({ ...state, loading: true, error: null })),
  on(complianceActions.loadJurisdictionRisksSuccess, (state, { response }) => ({ ...state, loading: false, data: response, error: null })),
  on(complianceActions.loadJurisdictionRisksFailure, (state, { error }) => ({ ...state, loading: false, error }))
);

export const getJurisdictionRisks = (state: StaticDataJurisdictionRisksState) => state.data;
export const getJurisdictionRisksLoading = (state: StaticDataJurisdictionRisksState) => state.loading;
export const getJurisdictionRisksError = (state: StaticDataJurisdictionRisksState) => state.error;